<template>
    <transition name="fade">
        <div class="scroll-top-btn" v-show="state.scY > 500" @click="toTop">
            <svg class="icon">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/local/templates/main/img/icons/sprite.svg#arrow-top"></use>
            </svg>
        </div>
  </transition>
</template>

<script>

import { ref, onMounted } from 'vue'

export default {
    name: 'ScrollToTop',
    setup: () => {

        const state = ref({
            scTimer: 0,
            scY: 0,
        })

        const handleScroll = () => {
            if (state.value.scTimer) return
            state.value.scTimer = setTimeout(() => {
                state.value.scY = window.scrollY
                clearTimeout(state.value.scTimer)
                state.value.scTimer = 0
            }, 100)
        }

        onMounted(() => {
            window.addEventListener('scroll', handleScroll)
        })

        const toTop = () => {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }

        return {
            state,
            toTop,
        }
    },
}
</script>

<style lang="scss">
    .scroll-top-btn {
        cursor: pointer;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        width: 50px;
        height: 50px;
        right: 33px;
        bottom: 150px;
        background: var(--c-gray-700);
        border-radius: var(--br-1);
        transition: all .3s ease;
        color: var(--c-gray-500);
        z-index: 120;

        @include tablet {
            bottom: 120px;
            right: 15px;
        }

        @include mobile {
            width: 40px;
            height: 40px;
            right: 11px;
            bottom: 70px;
        }

        &:hover {
            color: var(--c-gray-400);
        }
        &:active {
            color: var(--c-primary-200);
        }
        svg {
            width: 18px;
            height: 24px;
            fill: currentColor;
            @include mobile {
                width: 14px;
            }
        }
    }
</style>